import { useTranslate } from "src/i18n";

export const useNotFoundTranslates = () => {
  const { t } = useTranslate();
  return {
    title: t("error_page.not_found.title", "404"),
    description: t(
      "error_page.not_found.description",
      "Страница не найдена или была удалена.<br />Проверьте адрес или вернитесь на главную страницу.",
    ),
    actionText: t("error_page.action_text", "На главную"),
  };
};
